import { render, staticRenderFns } from "./ReturnPaymentPlanExtends.vue?vue&type=template&id=3b7e655a"
import script from "./ReturnPaymentPlanExtends.vue?vue&type=script&lang=js"
export * from "./ReturnPaymentPlanExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports